import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { isNotEmpty } from '../../../lib/ep';
import { useCSS } from '../../../lib/hooks';

import ActionLink from '../../builder/ActionLink';
import { localizeFields } from '../../builder/DynamicFields';

import TokenIcon from './TokenIcon';

export const formatTokenTitle = (token, amount = 1, lowercase = true) => {
	let label = "";
	if(isNotEmpty(token, 'title')) label = token.title;
	if(parseInt(amount) == 1 && isNotEmpty(token, 'title_singular')) label = token.title_singular;
	if(!lowercase || label == "") return label;
	return label.toLowerCase();
};

const TokenAmount = (props) => {
	useCSS('comp/multigallery.css');

	let token = props?.token ?? false;
	if(token === false) return null;
	[token] = localizeFields([token], props.locale);

	const type = props?.type ?? 'normal';

	const amount = props?.amount ?? 1;

	const label_title = formatTokenTitle(token, amount);

	if(['simple', 'wallet'].includes(type)) {
		return (
			<div class={`single_token is_${type}`}>
				<TokenIcon token={token} />

				{(type == 'simple' && isNotEmpty(token, 'image')) && (
					<strong>{amount}</strong>
				)}

				{(type == 'simple' && !isNotEmpty(token, 'image')) && (
					<strong>
						<FormattedMessage
							id="{qty} {coin_name}"
							values={{
								coin_name:label_title,
								qty:<strong>{amount}</strong>,
							}}
						/>
					</strong>
				)}

				{(type == 'wallet') && (
					<FormattedMessage
						id="Your {coin_name}: {qty}"
						values={{
							coin_name:token.title.toLowerCase(),
							qty:<strong>{amount}</strong>,
						}}
					/>
				)}

				{(props.link_props != undefined) && (
					<ActionLink
						{...props.link_props}
						_class={{ other:'is_fullscreen relative_to_container' }}
					/>
				)}
			</div>
		)
	}

	return (
		<span class="vote_label in_top in_detail">
			<span>
				<TokenIcon token={token} />

				<FormattedMessage
					id="{qty} {coin_name}"
					values={{
						coin_name:label_title.toLowerCase(),
						qty:amount,
					}}
				/>
			</span>
		</span>
	)
};

export default injectIntl(TokenAmount);